import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function OpeningHook() {
  return <section className="bg-beige py-20 px-4" data-id="element-131">
      <div className="max-w-3xl mx-auto" data-id="element-132">
        <FadeIn data-id="element-133">
          <div className="bg-white p-8 md:p-12 rounded-3xl shadow-sm border border-cream relative" data-id="element-134">
            <div className="absolute -top-6 -left-6 text-6xl text-terracotta opacity-20 font-heading" data-id="element-135">
              "
            </div>
            <p className="text-lg md:text-xl leading-relaxed text-brown-body italic" data-id="element-136">
              Te miras al espejo un lunes por la mañana y ocurre otra vez. El
              pantalón que te quedaba perfecto hace un mes hoy simplemente no
              cierra. No es que hayas comido de más este fin de semana; es esa
              pesadez dura, esa tirantez abdominal que te hace sentir como un
              globo a punto de estallar.
              <br data-id="element-137" />
              <br data-id="element-138" />
              Te sientes lenta, inflamada y con la mente nublada. Intentas tomar
              más café para arrancar, pero solo consigues más ansiedad y más
              hinchazón.
              <br data-id="element-139" />
              <br data-id="element-140" />
              <strong className="text-brown-dark font-semibold" data-id="element-141">
                No eres tú fallándole a tu cuerpo... es tu cuerpo enviándote una
                señal de socorro que nadie te ha enseñado a escuchar.
              </strong>
            </p>
            <div className="absolute -bottom-10 -right-6 text-6xl text-terracotta opacity-20 font-heading rotate-180" data-id="element-142">
              "
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}